import { Injectable, inject } from '@angular/core';
import axios from 'axios';
import type { ServiceAbilityRequest, ServiceAbilityResponse } from '../models/service-ability';
import { ShipmentFlowStateService } from '../services/shipment-flow-state.service';
import { AXIOS_INSTANCE } from './api-client.tokens';

@Injectable({ providedIn: 'root' })
export class ServiceAbilityApiService {
  private readonly http = inject(AXIOS_INSTANCE);
  private readonly shipmentFlowState = inject(ShipmentFlowStateService);

  /**
   * Checks whether the shipment route is serviceable via service-ability-service.
   * Non-2xx responses that include a serviceability payload are returned instead of thrown.
   * Sends the wizard flow id so a successful response can include a JWT attestation.
   */
  check(request: ServiceAbilityRequest): Promise<ServiceAbilityResponse> {
    const flowId = this.shipmentFlowState.ensureFlowId();

    return this.http
      .post<ServiceAbilityResponse>('/service-ability/check', request, {
        headers: { 'x-flow-id': flowId },
      })
      .then((response) => response.data)
      .catch((error: unknown) => {
        if (axios.isAxiosError(error) && error.response?.data) {
          const data = error.response.data as Partial<ServiceAbilityResponse>;
          if (typeof data.serviceable === 'boolean' && typeof data.message === 'string') {
            // Error envelopes never carry attestation — only successful 2xx bodies may.
            return {
              serviceable: data.serviceable,
              message: data.message,
              messageKey: typeof data.messageKey === 'string' ? data.messageKey : undefined,
            };
          }
        }

        throw error;
      });
  }
}
